export default __webpack_public_path__ + "static/media/82.96342b6c.svg";